import React, { useEffect, useState } from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { StyledFAB } from "../../components/CustomStyles/CustomFAB";
import BootstrapInputSearch from "../../components/InputSearch/BootstrapInputSearch";
import IzyPagination from "../../components/IzyPagination";
import IzyTabsPanel from "../../components/IzyTabsPanel";
import { handleError } from "../../components/Utils/Utils";
import { GetTotalPage } from "../../Helpers/pagination";
import ProductService from "../../Services/ProductService/ProductService";
import PropertyService from "../../Services/PropertyService/index";
import ProductStore from "../../Store/ProductStore";
import { productForm } from "./Container/NewForm";
import AddIcon from "@material-ui/icons/Add";
import { notifUtils } from "../../components/NotifUtils/NotifUtils";
import {
  Avatar,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  MenuItem,
  TableBody,
  TableContainer,
  TableHead,
  withWidth,
} from "@material-ui/core";
import {
  IZYTable,
  IZYTableRow,
  IZYTableCell,
} from "../../components/CustomStyles/CustomTable";
import Img from "../../components/Img";
import { formatCurrency } from "../../components/Utils/Currency";
import { Skeleton } from "@material-ui/lab";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import { usePrevState } from "../../Helpers/tools";
import { IzySwitch } from "../../components/CustomStyles/CustomSwitch";

const ProductListCard = (props) => {
  const {
    action,
    data,
    onClickAvailability,
    onClickEdit,
    onClickDelete,
    onBulkDelete,
    bulkDeleteStatus,
  } = props;
  const [checkbox, setcheckbox] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickEdit = () => {
    handleClose();
    onClickEdit(data);
  };

  const handleClickDeleteRestore = () => {
    handleClose();
    onClickDelete(data);
  };

  return (
    <IZYTableRow>
      {bulkDeleteStatus && (
        <IZYTableCell>
          <List style={{ padding: 0 }}>
            <ListItem style={{ padding: 0, marginLeft: "1.5rem" }}>
              <div className="d-flex">
                <input
                  style={{ scale: "1.5" }}
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  checked={checkbox}
                  onChange={() => {
                    setcheckbox(!checkbox);
                    if (!checkbox === true) {
                      // console.log("masuktru");
                      onBulkDelete(data.id, "add");
                    }
                    if (!checkbox === false) {
                      // console.log("masukfalse");
                      onBulkDelete(data.id, "del");
                    }
                  }}
                />
              </div>
            </ListItem>
          </List>
        </IZYTableCell>
      )}
      <IZYTableCell>
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Avatar variant="rounded">
                <Img
                  src={data.main_image || data.image_urls[0]}
                  width={60}
                  height={60}
                />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={<span className="font-11 font-bold">{data.name}</span>}
            />
          </ListItem>
        </List>
      </IZYTableCell>
      <IZYTableCell>{data.product_code || "-"}</IZYTableCell>
      <IZYTableCell>{data.stock || "0"}</IZYTableCell>
      <IZYTableCell>
        {data.discounted_price && (
          <React.Fragment>
            <span className="text-decoration-line-through d-block">
              {formatCurrency(
                data.tenant.property.currency,
                data.price.value.toString()
              )}
            </span>
            <span className="font-11">
              {formatCurrency(
                data.tenant.property.currency,
                data.discounted_price.toString()
              )}
            </span>
          </React.Fragment>
        )}
        {!data.discounted_price && (
          <span className="font-11">
            {formatCurrency(
              data.tenant.property.currency,
              data.price.value.toString()
            )}
          </span>
        )}
      </IZYTableCell>
      <IZYTableCell>
        <IzySwitch
          size="small"
          checked={!data.out_of_stock}
          color="primary"
          name="out_of_stock"
          onChange={() => {
            onClickAvailability(data);
          }}
          disabled={!action.patch || !action.update}
        />
      </IZYTableCell>
      <IZYTableCell>
        {(action.update || action.delete) && (
          <React.Fragment>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {action.update && (
                <MenuItem onClick={handleClickEdit}>Edit</MenuItem>
              )}
              {action.delete && action.patch && (
                <MenuItem onClick={handleClickDeleteRestore}>
                  {data.deleted_st ? "Restore" : "Delete"}
                </MenuItem>
              )}
            </Menu>
          </React.Fragment>
        )}
      </IZYTableCell>
    </IZYTableRow>
  );
};

const ProductListCardLoading = () => {
  return (
    <IZYTableRow>
      <IZYTableCell>
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Avatar variant="rounded">
                <Skeleton
                  variant="rect"
                  animation="wave"
                  width={60}
                  height={60}
                />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={<Skeleton animation="wave" height={22} />} />
          </ListItem>
        </List>
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell></IZYTableCell>
    </IZYTableRow>
  );
};

const NewProduct = ({ width, params }) => {
  const [arrStatus, setArrStatus] = React.useState([
    {
      title: "Product List",
      sub_title: 0,
      deleted: false,
      status: "available",
      total_data: 0,
      active: false,
    },
    {
      title: "Removed Product List",
      sub_title: 0,
      deleted: true,
      status: "deleted",
      total_data: 0,
      active: false,
    },
  ]);

  const [productState, productActions] = ProductStore();
  const [perPage, setPerPage] = React.useState(10);
  const [totalPage, setTotalPage] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [statusActive, setStatusActive] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const prevPage = usePrevState(page);
  const prevSearch = usePrevState(search);
  const [selectedBulkDelete, setselectedBulkDelete] = useState([]);
  // console.log(selectedBulkDelete, "<<<<<<<<");
  const [bulkDeleteStatus, setbulkDeleteStatus] = useState(false);
  const toggleStatus = (index) => {
    setStatusActive(index);
    setPage(1);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  // console.log(arrStatus);
  const user = JSON.parse(localStorage.getItem("user"));

  const [isLoading, setisLoading] = useState(true);
  const handleGetProductList = async () => {
    let newDataProperty = "";
    if (user?.operational?.level < 3) {
      const res = await PropertyService.getList({
        num: 10,
        operational_level: user?.operational?.level,
        level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
        cursor: "",
        parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
        type: "",
      });
      console.log(res.data.id);
      // console.log("^^^^^");

      res.data.map((e) => {
        // return e.id
        newDataProperty += e.id + ",";
      });
    }

    // console.log(newDataProperty.slice(0, newDataProperty.length - 1));

    var query = {
      page: page || 1,
      perPage: perPage,
      deleted: arrStatus[statusActive].deleted === true ? "true" : "false",
      keyword: search,
      property_id: newDataProperty.slice(0, newDataProperty.length - 1) || "",
    };
    productActions.getList(query);
  };

  const handleGetResume = async (pararel) => {
    const res = await PropertyService.getList({
      num: 10,
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      cursor: "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      type: "",
    });
    console.log(res.data.id);

    let newDataProperty = "";
    res.data.map((e) => {
      // return e.id
      newDataProperty += e.id + ",";
    });

    var params = {
      keyword: search,
      property_id: newDataProperty.slice(0, newDataProperty.length - 1) || "",
    };

    ProductService.getResume(params)
      .then((response) => {
        let data = response.data;

        const remapStatus = arrStatus.map((value, index) => {
          return {
            ...value,
            sub_title: data[value.status] || 0,
            total_data: data[value.status] || 0,
            active: data[value.status] > 0 ? true : false,
          };
        });
        console.log(remapStatus);
        console.log("***********");
        setArrStatus(remapStatus);

        if (pararel) {
          handleGetProductList();
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  const handleChangePerPage = (perPage) => {
    setPerPage(perPage);
  };

  const handleActions = (value) => {
    if (value) {
      productForm("Update Product", value).then(
        (onProcess) => {},
        (onCancel) => {
          handleGetProductList();
        }
      );
    } else {
      productForm("Create Product", null).then(
        (onProcess) => {},
        (onCancel) => {
          handleGetResume(true);
        }
      );
    }
  };

  const setAvailability = (data) => {
    confirm(
      !data.out_of_stock ? "Set Item Not Available" : "Set Available",
      !data.out_of_stock
        ? "Set this Item Not Available ?"
        : "Set this Item Available ?"
    ).then(async (onProcess) => {
      const params = [
        {
          op: "replace",
          path: "/out_of_stock",
          value: !data.out_of_stock,
        },
      ];
      let notif = `Successfully ${
        !data.out_of_stock ? "Set Item Not Available" : "Set Available"
      }`;
      await productActions.patch(data.id, params, notif);
      handleGetProductList();
    });
  };

  const setStatusRemove = (data) => {
    confirm(
      `${!data.deleted_st ? "Remove Item" : "Restore Item"}`,
      `Are you sure to ${!data.deleted_st ? "remove" : "restore"} this item ?`
    ).then(async (onProcess) => {
      if (!data.deleted_st) {
        await productActions.deleted(data.id);
      } else {
        const params = [
          {
            op: "replace",
            path: "/deleted ",
            value: false,
          },
        ];
        let notif = `Successfully Restore Product`;
        await productActions.patch(data.id, params, notif);
      }

      handleGetResume(true);
    });
  };

  const handleBulkDeleted = (data) => {
    console.log(data);
    if (data.length === 0) {
      notifUtils("Please Select One Product", "error");
      // await productActions.deleted(data.id);
      console.log("gada delete");
    } else {
      confirm(
        `Remove All Item Selected`,
        `Are you sure to remove all selected item ?`
      ).then(async (onProcess) => {
        if (data.length === 0) {
          notifUtils("Please Select One Product", "error");
          // await productActions.deleted(data.id);
          console.log("gada delete");
        } else {
          let notif = `Successfully Remove Product`;
          await productActions.bulkDelete(data, notif);
        }
        handleGetResume(true);
        setbulkDeleteStatus(false);
      });
    }
  };

  React.useEffect(() => {
    const getTotalPage = GetTotalPage(
      arrStatus[statusActive]["total_data"],
      perPage
    );
    // console.log(getTotalPage);
    // console.log(">>>>>>>>");
    setTotalPage(getTotalPage);
  }, [arrStatus, statusActive, perPage]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetResume();
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetProductList();
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      const newPage = prevPage > 1 ? 1 : "";
      if (prevPage) {
        setPage(newPage);

        if (prevPage === newPage) {
          handleGetProductList();
        }
      } else if (prevPage === "" && page === "") {
        setPage(1);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [search, perPage, statusActive]);
  useEffect(() => {
    handleGetProductList();
  }, []);

  const handleBulkDelete = (id, param) => {
    console.log(id, param);
    if (param === "add") {
      setselectedBulkDelete([...selectedBulkDelete, { id }]);
    }
    if (param === "del") {
      const afterdelete = selectedBulkDelete.filter((e) => e.id !== id);
      setselectedBulkDelete(afterdelete);
    }
  };
  console.log(selectedBulkDelete);
  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-12 px-0">
          <h3 className="font-16 font-bold mb-0">
            Product / Product Managements
          </h3>
        </div>
        <div className="col-12 px-0">
          <div className="card rounded-8px border-0 mt-4">
            <div className="card-body border-0 px-4 pt-4 pb-0">
              <div className="w-100 d-flex justify-content-between align-items-center">
                <BootstrapInputSearch
                  placeholder="Search Product"
                  onChange={(e) => handleSearch(e)}
                />
                {width !== "sm" && width !== "xs" && params.create && (
                  <div className="d-flex flex-column">
                    <button
                      type="button"
                      className="btn btn-blue"
                      onClick={() => handleActions(null)}
                    >
                      CREATE
                    </button>
                  </div>
                )}
              </div>
              <div className="d-flex flex-row w-100  justify-content-between">
                <p className="font-12 font-bold my-3">Status</p>
                {params.create && statusActive === 0 && (
                  <div>
                    {!bulkDeleteStatus ? (
                      <button
                        type="button"
                        className="btn btn-danger p-2 rounded-lg mt-3"
                        onClick={() => setbulkDeleteStatus(true)}
                      >
                        Bulk Delete
                      </button>
                    ) : (
                      <div>
                        <div className="">
                          <button
                            type="button"
                            className="btn btn-success p-2 rounded-lg mt-3"
                            onClick={() =>
                              handleBulkDeleted(selectedBulkDelete)
                            }
                          >
                            Confirm
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger p-2 rounded-lg mt-3 ml-2"
                            onClick={() => setbulkDeleteStatus(false)}
                          >
                            Cancel
                          </button>
                        </div>
                        {/* <p>dsadsa</p> */}
                      </div>
                    )}
                  </div>
                )}{" "}
              </div>
              <IzyTabsPanel
                tabs={arrStatus}
                tabActive={statusActive}
                onClick={(index) => {
                  // console.log(index);
                  // console.log("pppppppp");
                  toggleStatus(index);
                }}
              />
            </div>

            <div className="card-body border-0 px-4 pt-0 pb-4">
              <TableContainer>
                <IZYTable>
                  <TableHead>
                    <IZYTableRow>
                      {bulkDeleteStatus && (
                        <IZYTableCell align="left" width="10%">
                          Checklist
                        </IZYTableCell>
                      )}
                      <IZYTableCell align="left" width="30%">
                        Product
                      </IZYTableCell>
                      <IZYTableCell align="left" width="20%">
                        Product Code
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Stock
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Price
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Availability
                      </IZYTableCell>
                      <IZYTableCell align="left" width="5%"></IZYTableCell>
                    </IZYTableRow>
                  </TableHead>
                  <TableBody>
                    {!productState.isLoading &&
                      productState.data.length > 0 &&
                      productState.data.map((value, key) => {
                        return (
                          <ProductListCard
                            key={key}
                            data={value}
                            onClickAvailability={(data) =>
                              setAvailability(data)
                            }
                            onClickEdit={(data) => {
                              handleActions(data);
                            }}
                            onClickDelete={(data) => {
                              setStatusRemove(data);
                            }}
                            onBulkDelete={(data, data2) => {
                              handleBulkDelete(data, data2);
                            }}
                            action={params}
                            selectedBulkDelete={selectedBulkDelete}
                            bulkDeleteStatus={bulkDeleteStatus}
                          />
                        );
                      })}

                    {productState.isLoading &&
                      Array.from(new Array(perPage)).map((value, key) => {
                        return <ProductListCardLoading key={key} />;
                      })}
                  </TableBody>
                </IZYTable>
              </TableContainer>
            </div>
          </div>
          <IzyPagination
            page={page || 1}
            perPage={perPage}
            total={arrStatus[statusActive]["total_data"] || 0}
            totalPage={totalPage}
            onChangePage={(page) => handleChangePage(page)}
            onChangePerPage={(perPage) => handleChangePerPage(perPage)}
          />
        </div>
      </div>
      {(width === "sm" || width === "xs") && params.create && (
        <StyledFAB color="primary" onClick={() => handleActions(null)}>
          <AddIcon />
        </StyledFAB>
      )}
    </BaseLayout>
  );
};

export default withWidth()(NewProduct);
